import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  createFormField,
  FormFieldBlueprint,
} from '@backstage/plugin-scaffolder-react/alpha';

import { KaapAzureToken } from './fields/KaapAzureToken';
import {
  KaapTenantForm,
  kaapTenantFormValidation,
} from './fields/KaapTenantForm';

// `name` is the value used as `ui:field` in the template YAML.
const fields: Array<{
  id: string;
  name: string;
  component: any;
  validation?: any;
}> = [
  {
    id: 'kaap-tenant-form',
    name: 'KaapTenantForm',
    component: KaapTenantForm,
    validation: kaapTenantFormValidation,
  },
  { id: 'kaap-azure-token', name: 'KaapAzureToken', component: KaapAzureToken },
];

/**
 * Registers the custom scaffolder form-field extensions used by the KaaP tenant
 * templates: the consolidated `KaapTenantForm` (create / edit) and the
 * standalone `KaapAzureToken` (delete). Attaches to the scaffolder page's
 * `formFields` input via `pluginId: 'scaffolder'`.
 */
export const kaapScaffolderFieldsModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: fields.map(({ id, name, component, validation }) =>
    FormFieldBlueprint.make({
      name: id,
      params: {
        field: async () => createFormField({ name, component, validation }),
      },
    }),
  ),
});
